import { Sticker } from '@shopby/shop-sdk'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, NavigateFunction, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { formatNumberWithTruncation, onErrorImg, plusComma } from '../../js/script'
import LikeBtn from '../btn/LikeBtn'
import { Button } from '../Button'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'
import { useCommonContext } from '../provider/CommonProvider'
import { IconStarOn } from '../svg/IconSvg'
import { useAppContext } from '../provider/AppProvider'

// 이미지 경로
const imgURL = '/images'

type PropsType = {
  item: any
  setSubmitWish: React.Dispatch<React.SetStateAction<boolean>>
  items: any
}

export default function ShoppingProductItem({ item, setSubmitWish, items }: PropsType) {
  const { isAppView } = useAppContext()
  const { hasAccessToken, setIsLogin } = useCommonContext()
  const navigate: NavigateFunction = useNavigate()

  const [wish, setWish] = useState<boolean>(item.liked)
  const [disCountAcc, setDisCountAcc] = useState<number>(0)
  const [text, setText] = useState<Sticker[]>([])
  const [image, setImage] = useState<Sticker[]>([])
  const [wonShop, setWonShop] = useState<boolean>(false)
  const [isModals, setIsModals] = useState<boolean>(false)

  useEffect(() => {
    if (item) {
      if (item.displayCategoryNos === '787334') {
        setWonShop(true)
      }
    }
  }, [item])

  useEffect(() => {
    if (item) {
      const count = formatNumberWithTruncation((item?.salePrice - item?.immediateDiscountAmt) * 0.1)
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [item])

  useEffect(() => {
    setImage([])
    setText([])
  }, [item])

  useEffect(() => {
    if (item) {
      const newImages: any = []
      const newTexts: any = []

      item.stickerInfos?.forEach((element: any) => {
        if (element.type === 'IMAGE') {
          newImages.push(element)
        } else {
          newTexts.push(element)
        }
      })

      setImage((prev: any) => [...prev, ...newImages])
      setText((prev: any) => [...prev, ...newTexts])
    }
  }, [item])

  useEffect(() => {
    setWish(item.liked)
  }, [item])

  return (
    // 상품내역 wrap
    <div className='product_item_wrap'>
      {/* 상품이미지 영역 */}
      <div className='product_image_area'>
        <LikeBtn item={item} />
        {image.map((element: any, index: number) => (
          <div className='item_flag' key={index}>
            <img src={element.label} alt='' />
          </div>
        ))}
        <div
          onClick={() => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
              })
            } else {
              navigate(`/product/${item.productNo}`)
            }
          }}
        >
          <div className='dim'></div>
          <img src={item.listImageUrls[0]} alt='' onError={onErrorImg} />
        </div>
      </div>

      {/* 장바구니 버튼 */}
      <button
        className='btn_cart'
        onClick={() => {
          setIsModals(true)
        }}
      >
        <img src={`${imgURL}/icon_cart.png`} alt='장바구니' />
        {item?.isSoldOut ? '재입고 알림' : '장바구니'}
      </button>

      <div
        className='product_item'
        onClick={() => {
          if (isAppView) {
            RNPostMessage(AFWebLinkType.moveToLink, {
              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
            })
          } else {
            navigate(`/product/${item.productNo}`)
          }
        }}
      >
        {/* 브랜드명 */}
        {item.brandName ? <div className='product_brand_title'>{item.brandName}</div> : null}

        {/* 상품명 */}
        <div className='product_title'>{item.productName}</div>

        {Math.floor((item.immediateDiscountAmt / item.salePrice) * 100) === 0 ? (
          <>
            <div className='discounted_price'>
              {/* 상품 할인 적용가 */}
              <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
            </div>
          </>
        ) : (
          <>
            {/* 원 상품가 */}
            <div className='product_sale_price'>{plusComma(item.salePrice)}원</div>

            <div className='discounted_price'>
              <p className='percent'>{Math.floor((item.immediateDiscountAmt / item.salePrice) * 100)}%</p>

              {/* 상품 할인 적용가 */}
              <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
            </div>
          </>
        )}

        {/* 최대혜택가 */}

        {!item?.accumulationUseInfo?.usable && !item.enableCoupons ? null : item?.salePrice -
            item?.immediateDiscountAmt -
            item?.couponDiscountAmt -
            (item?.accumulationAmtWhenBuyConfirm !== 0 ? item?.accumulationAmtWhenBuyConfirm : 0) -
            (item?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) ===
          Number(item?.salePrice - item?.immediateDiscountAmt) ? null : (
          <div className='max_benefit'>
            <p className='badge'>회원혜택가</p>
            <>
              <p>
                {plusComma(
                  item?.salePrice -
                    item?.immediateDiscountAmt -
                    item?.couponDiscountAmt -
                    (item?.accumulationAmtWhenBuyConfirm !== 0 ? item?.accumulationAmtWhenBuyConfirm : 0) -
                    (item?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) <
                    0
                    ? 0
                    : item?.salePrice -
                        item?.immediateDiscountAmt -
                        item?.couponDiscountAmt -
                        (item?.accumulationAmtWhenBuyConfirm !== 0 ? item?.accumulationAmtWhenBuyConfirm : 0) -
                        (item?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0)
                )}
                원
              </p>
            </>
          </div>
        )}

        {/* 페이백 적립금 5% + 추가적립금 */}
        {hasAccessToken && item?.accumulationInfo?.amount > 0 ? (
          <div className='save_mileage'>
            <p>
              {`페이백 적립금 ${item?.accumulationInfo.rewardRateOfProduct}% `}
              {plusComma(item?.accumulationInfo?.amount)}
              <img src={`${imgURL}/icon_point.png`} alt='' />
            </p>
          </div>
        ) : null}

        {/* 별점 */}
        <div className='star_rating'>
          <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
          <span className='review_rating'>{item?.reviewRating}</span>
          <span className='review_num'>({item?.totalReviewCount})</span>

          {/* Npay */}
          <div className='npay'>
            <img src={`${imgURL}/icon_npay.png`} alt='Naver Pay' />
          </div>
        </div>

        {/* 당일배송, 오늘만 특가 */}
        {text.length !== 0 ? (
          <div className='item_txt_flag'>
            {text.map((el: any, index: number) => {
              return (
                <span className='delivery' key={`${index}1`}>
                  {el.label}
                </span>
              )
            })}
          </div>
        ) : null}
      </div>
      {isModals ? (
        isMobile ? (
          <ProductModal
            setIsModal={setIsModals}
            headerText={'옵션선택'}
            selectProductNo={item.productNo}
            wonShopBol={wonShop}
            listItem={items}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModals}
            headerText={'옵션선택'}
            selectProductNo={item.productNo}
            wonShopBol={wonShop}
            listItem={items}
          ></ProductCenterModal>
        )
      ) : null}
    </div>
  )
}
// 각 상품 wrap
export const ProductItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  width: 100%;
`
// 상품 브랜드명
export const ProductBrandTitile = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  margin-bottom: 4px;
`
// 상품명
export const ProductTitle = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: 8px;
  font-weight: 500;
  line-height: 18px;
`
// 장바구니 버튼
export const BtnCart = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 7px;
  margin-bottom: 10px;
  color: var(--colBlack);
  border-radius: 4px;
  border: 1px #e9e9e9 solid;
  & img {
    width: 20px;
    height: 20px;
  }
`
// 상품 이미지 영역
export const ProductImageArea = styled.div`
  position: relative;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;

  & div.dim {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.03;
    z-index: 2;
  }
  & img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
`
// 상품 판매가
export const ProductSalePrice = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-decoration-line: line-through;
  color: var(--colGray5);
`

// 상품 할인 퍼센트, 가격
export const DiscountedPrice = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 6px;

  & p {
    display: flex;
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
  }
  & p.percent {
    color: var(--colPointOrange);
  }
`

// 상품 최대혜택가
export const MaximumBenefit = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;

  /* 최대혜택가 */
  & p {
    display: flex;
    justify-content: center;
    font-size: 15px;
    font-weight: 600;
    line-height: 16px;
    color: var(--colPointOrange);
  }
  /* 최대혜택가 badge */
  & p.badge {
    background: var(--colPointOrange);
    width: 56px;
    padding: 3px 6px;
    background: var(--colPointOrange);
    border-radius: 9px;
    font-size: 10px;
    color: var(--colWhite);
    line-height: 12px;
  }
`
// 별점, 리뷰
export const StarRating = styled.div`
  display: flex;
  align-items: center;

  /* 별점 */
  & p {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }
  & p:first-child {
    margin-right: 2px;
  }
  /* 리뷰 */
  & p.review_num {
    font-size: 13px;
    font-weight: 500;
    color: var(--colGray5);
    margin-left: 4px;
  }
`
